import Swiper from 'swiper';
import { Navigation, Pagination, A11y, Autoplay } from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/a11y';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

const rootStyles = getComputedStyle(document.documentElement);
const galleryGap = parseInt(rootStyles.getPropertyValue('--media-gallery-gap').trim()) || 32;
const galleryGapTablet = parseInt(rootStyles.getPropertyValue('--media-gallery-gap-tablet').trim()) || 24;

const commonCarouselSettings = {
    modules: [Navigation, Pagination, A11y, Autoplay],
    a11y: {
        enabled: true
    },
    navigation: {
        addIcons: false,
        nextEl: '.carousel-button-next',
        prevEl: '.carousel-button-prev'
    },
    pagination: {
        el: '.swiper-pagination',
        clickable: true,
        bulletClass: 'swiper-pagination-bullet carousel-dot',
        bulletActiveClass: 'swiper-pagination-bullet-active carousel-dot-active'
    },
    centeredSlides: false,
    centeredSlidesBounds: true,
    initialSlide: 0,
    preventClicksPropagation: true,
    touchMoveStopPropagation: true,
    spaceBetween: galleryGapTablet,
    slideToClickedSlide: false,
    // workaround for focus bug affecting interactive slide content such as audio
    watchSlidesProgress: true
}

const carouselEls = Array.from(document.querySelectorAll('[data-gallery]')) as HTMLElement[];
const carousels: Swiper[] = [];
carouselEls.forEach(carouselEl => {
    const galleryType = carouselEl.getAttribute('data-gallery-type');
    const perPage = carouselEl != null ? parseFloat(carouselEl.getAttribute('data-per-page')) : 4;
    const autoplay = carouselEl.getAttribute('data-autoplay') != null ? carouselEl.getAttribute('data-autoplay') == "true" : false;
    let autoplaySettings: any = {};
    let breakpoints: any = {};
    if (autoplay) {
        const interval = carouselEl.getAttribute('data-interval') != null ? carouselEl.getAttribute('data-interval') : "1000000";
        autoplaySettings = {
            autoplay: {
                delay: parseFloat(interval),
                disableOnInteraction: false
            }
        }
    }
    if (perPage > 1) {
        breakpoints = {
            1280: {
                spaceBetween: galleryGap,
                slidesPerView: perPage
            },
            768: {
                spaceBetween: galleryGap,
                slidesPerView: Math.max(1, perPage - 1)
            },
            640: {
                spaceBetween: galleryGapTablet,
                slidesPerView: Math.max(1, perPage - 2)
            }
        }
    };
    const carousel = new Swiper(carouselEl, {
        ...commonCarouselSettings,
        ...autoplaySettings,
        slidesPerView: 1,
        breakpoints: {
            ...breakpoints
        },
        init: false
    });
    carousels.push(carousel);

    if (autoplay) {
        const pauseButton = carouselEl.querySelector('[data-carousel-pause]') as HTMLButtonElement;
        pauseButton?.addEventListener('click', () => {
            if (carousel.autoplay.running) {
                carousel.autoplay.stop();
                pauseButton.setAttribute('aria-pressed', "true");
            }
            else {
                carousel.autoplay.start();
                pauseButton.setAttribute('aria-pressed', "false");
            }
        });
    }
});

setTimeout(() => {
    carousels.forEach(carousel => {
        carousel.init();
    });
}, 100);